import { DropdownContentData } from '@legacyApp/client/store/dropdown/dropdown.reducer';
import { actionSimple } from '../../modules/app/actionService';
import {
	DROPDOWN_ADD,
	DROPDOWN_DELETE,
	DROPDOWN_SET_ACTIVE,
	DROPDOWN_SET_CONTENT,
	DROPDOWN_TOGGLE,
} from './dropdown.constants';

export const dropdownSetActive = actionSimple<{
	id: string;
}>(DROPDOWN_SET_ACTIVE);
export const dropdownSetContent = actionSimple<{
	id: string;
	content: DropdownContentData;
}>(DROPDOWN_SET_CONTENT);
export const dropdownDelete = actionSimple<string>(DROPDOWN_DELETE);
export const dropdownAdd = actionSimple<{
	id: string;
	content: DropdownContentData;
}>(DROPDOWN_ADD);
export const dropdownToggle = actionSimple<{
	id: string;
	bool: boolean;
}>(DROPDOWN_TOGGLE);
